import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSigma = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M19.69 2.99995H5.62312C5.49994 2.9999 5.37951 3.03637 5.27706 3.10475C5.17461 3.17313 5.09474 3.27036 5.04754 3.38413C5.00034 3.4979 4.98794 3.62312 5.0119 3.74394C5.03586 3.86476 5.09511 3.97577 5.18215 4.06292L12.5806 11.4613C12.8141 11.6949 12.9453 12.0117 12.9453 12.342C12.9453 12.6723 12.8141 12.9891 12.5806 13.2227L5.18215 20.6211C5.09523 20.7084 5.03609 20.8194 5.01219 20.9403C4.9883 21.0611 5.00071 21.1863 5.04788 21.3001C5.09504 21.4139 5.17484 21.5111 5.27721 21.5796C5.37959 21.6481 5.49995 21.6848 5.62312 21.6849H19.69",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgSigma;
